import type {} from "@lit/react";
import { DashboardSection as DashboardSectionElement, } from "@vaadin/dashboard/vaadin-dashboard-section.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DashboardSectionElement, };
export type DashboardSectionEventMap = Readonly<{}>;
const events = {} as DashboardSectionEventMap;
export type DashboardSectionProps = WebComponentProps<DashboardSectionElement, DashboardSectionEventMap>;
export const DashboardSection = createComponent({
    elementClass: DashboardSectionElement, events, react: React, tagName: "vaadin-dashboard-section"
});
